import { useMemo, useState } from "react";
import "./styles.sass";
import useHandler from "./handler";
export const TeacherLeaderBaord = () => {
  const {
    boardData,
    startItem,
    endItem,
    totalPages,
    currentStudents,
    currentPage,
    setCurrentPage,
  } = useHandler();

  const maxTests = Math.max(
    ...(boardData || [])?.map((item) => item?.tests_attended || 0),
    1,
  );

  return (
    <section className="teacher_leaderboard">
      <section className="teacher_leaderboard_header">
        <div>
          <h2>Leaderboard</h2>

          <p>Top performing students based on average marks</p>
        </div>

        {/* <button className="export_btn">Export</button> */}
      </section>
      <table>
        <thead>
          <tr>
            <th>Rank</th>
            <th>Student Information</th>
            <th>Test Attended</th>
            <th>Score Obtained</th>
            <th>Best Attempted Score</th>
            <th>Average Score</th>
            <th>Overall %</th>
          </tr>
        </thead>

        <tbody>
          {currentStudents?.map((item, index) => (
            <tr key={index}>
              <td>
                <div className="rank">
                  #{item.rank}
                  {/*                   
                  {item?.overall_percentage <= 100
                    ? // && item?.overall_percentage >= 95
                      "🏅"
                    : `#${item.rank}`} */}
                </div>
              </td>

              <td>
                <div className="student_info">
                  <div className="avatar">
                    {(
                      item.name?.[0] ||
                      item?.user_mail?.[0] ||
                      "-"
                    ).toUpperCase()}
                  </div>

                  <div>
                    <h4>{item?.name || "-"}</h4>

                    <span>{item?.user_mail}</span>
                  </div>
                </div>
              </td>

              <td>
                {/* <div className="score"> */}
                <h4 className="test-attend">{item?.tests_attended}</h4>

                {/* <div className="progress">
                    <div
                      className="fill"
                      style={{
                        width: `${item?.tests_attended / maxTests}%`,
                      }}
                    />
                  </div> */}
                {/* </div> */}
              </td>

              <td>{item?.total_marks_scored}</td>

              <td className="green">
                {item?.best_attempt_score
                  ? String(item.best_attempt_score).replace(/\s*out\s*of\s*/gi, " / ")
                  : item?.total_max_marks ?? "-"}
              </td>
              <td>{item?.avg_marks}</td>

              <td
                className={
                  Number(item.overall_percentage) < 0
                    ? "improvement_danger"
                    : "improvement"
                }
              >
                {item?.overall_percentage}%
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination_container">
        <div className="pagination_info">
          Showing {startItem}
          to {endItem}
          of {boardData?.length}
          students
        </div>

        <div className="pagination">
          <button
            className="page_btn"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            {"<"}
          </button>

          {Array.from(
            {
              length: totalPages,
            },
            (_, i) => (
              <button
                key={i}
                className={`page_btn ${currentPage === i + 1 ? "active" : ""}`}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ),
          )}

          <button
            className="page_btn"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            {">"}
          </button>
        </div>
      </div>
    </section>
  );
};
